import assets from './assets';

export default {
  start: {
    video: assets.startVideo,
  },
  end: {
    ctaUrl: '#scheduler',
  },
  scenarios: [
    {
      key: 'scenarioA',
      title: 'App Integration',
      steps: [
        {
          key: 'stepA1',
          withNextSteps: true,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen0,
          hotspots: [{ x: 170, y: 435, goTo: 'stepA2' }],
        },
        {
          key: 'stepA2',
          withNextSteps: true,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen1,
          hotspots: [{ x: 235, y: 220, goTo: 'stepA3' }],
        },
        {
          key: 'stepA3',
          withNextSteps: true,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen2,
          hotspots: [{ x: 1200, y: 90, goTo: 'stepA4' }],
        },
        {
          key: 'stepA4',
          withNextSteps: true,
          withMore: false,
          withBody: true,
          withBullets: [
            {
              key: 'bullet1',
              goTo: 'stepA4',
            },
            {
              key: 'bullet2',
              goTo: 'stepA4',
            },
            {
              key: 'bullet3',
              goTo: 'stepA4',
            },
          ],
          imagePath: assets.screen3,
          hotspots: [{ x: 1200, y: 90, goTo: 'stepA5' }],
        },
        {
          key: 'stepA5',
          withNextSteps: true,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen4,
          hotspots: [{ x: 1250, y: 20, goTo: 'stepA6' }],
        },
        {
          key: 'stepA6',
          withNextSteps: true,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen5,
          hotspots: [{ x: 1180, y: 200, goTo: 'stepA7' }],
        },
        {
          key: 'stepA7',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen6,
        },
        {
          key: 'stepA8',
          withNextSteps: false,
          withMore: false,
          withBody: true,
          withBullets: [],
          imagePath: assets.screen7,
        },
      ],
    },
  ],
};
